import cloneDeep from 'lodash/cloneDeep'
import { upload } from '@/api/file'
import { reqs } from '@/http/axios'

const modal: any = {
  namespaced: true,
  state() {
    return {
      // 一个临时任务包含多个上传文件（一对多）
      showTasks: false,
      taskList: [],
      // 固定任务中有文件类型任务，不能文件管理操作
      locked: false,
    }
  },
  mutations: {
    async addOtherTask(state, payload) {
      // 未完成临时任务
      if (state.taskList[0]?.loading) {
        return Xinnet.message.warning(
          '当前有任务尚未运行完成，请等待完成后重试。'
        )
      }
      const fileList: any = [{ done: false }]
      state.taskList = [createTask(fileList, payload), ...state.taskList]
      // state.showTasks = true
      const task = state.taskList[0]
      task.loading = true
      task.cancel = false
      task.createTime = Xinnet.util.formatTime(new Date())
    },
    async updateOtherTask(state, payload) {
      const task = state.taskList[0]
      if (payload.taskType === 'DECOMPRESS') {
        if (payload.taskStatus) {
          task.taskInfo = payload.taskInfo
          task.taskStatus = payload.taskStatus
          if (task.taskStatus === 'RUNNING_FAIL') {
            task.failed = true
          } else {
            task.failed = false
          }
        }
        if (payload.done) {
          task.loading = false
          task.fileList[0].done = true
          task.endTime = Xinnet.util.formatTime(new Date())
        } else {
          task.filename = payload.filename
          task.processed = payload.processed
          task.total = payload.total  
        }
      } else {
        if (payload.progress === 100) {
          task.loading = false
          task.progress = 100
          task.filename = payload.filename
          task.endTime = Xinnet.util.formatTime(new Date())
          task.fileList[0].done = true
        } else {
          if (payload.progress < 100) {
            task.progress = payload.progress
          }
        }

        if (payload.downloaded) {
          task.downloaded = payload.downloaded
        }
        if (payload.rate) {
          task.rate = payload.rate
        }
      }
    },
    // 添加上传文件临时任务
    async addTask(state, payload: any) {
      if (!payload?.data?.length) return
      // 未完成临时任务
      if (state.taskList[0]?.loading) {
        return Xinnet.message.warning(
          '当前有任务尚未运行完成，请等待完成后重试。'
        )
      }
      // 仅有一个未完成临时任务
      state.taskList = [
        createTask(payload.data, { taskType: 'UPLOAD_FILE' }),
        ...state.taskList
      ]
      const task = state.taskList[0]
      if (task) {
        // state.showTasks = true
        task.loading = true
        task.cancel = false
        task.createTime = Xinnet.util.formatTime(new Date())
        await uploadFiles(task, payload.path, payload.callback)
      }
    },
    stopTask(state) {
      // 仅上传可以终止任务
      aborts()
      state.taskList.forEach((task) => {
        task.cancel = true
        task.fileList?.forEach((file) => {
          file.loading = false
        })
        task.endTime = Xinnet.util.formatTime(new Date())
      })
    },
    updateTaskState(state, payload) {
      const { task, value } = payload
      if (task && value) {
        const res = state.taskList.find((t) => t.id === task.id)
        if (res) res.notifyStatus = value
      }
    },
    triggerTask(state, payload)  {
      state.showTasks = payload
    },
    setLocked(state, payload) {
      state.locked = payload
    }
  },
  actions: {}
}

// 创建空任务
const createTask = (fileList = [], restProps = {}) => {
  return {
    id: Math.floor(Math.random() * 100000000),
    createTime: null,
    endTime: null,
    loading: false,
    // 上传任务进度
    progress: 0,
    // 取消任务
    cancel: false,
    // 已上传文件大小
    size: '',
    totalSize: '',
    fileList,
    // 上传文件百分比
    ratio: 0,
    // 第几个文件
    whichFile: 1,
    notifyStatus: 0,
    // taskType,
    ...restProps,
  }
}

const chunkSize = 4 * 1024 * 1024
// 获取分片总数
// const getChunkTotalCount = (fileList) => {
//   const list = cloneDeep(fileList)
//   let count = 0
//   let file
//   while(file = list.shift()) {
//     count += Math.ceil(file.size / chunkSize)
//   }
//   return count
// }

const blacklist = [
  '/upload',
]
const aborts = () => {
  for (const key in reqs) {
    const exist = blacklist.find(api => key.startsWith(api))
    if (exist) {
      reqs[key].controller?.abort()
    }
  }
}


// 分片上传文件
const uploadFile = async (task, file, path, index, done, allDone, restFiles) => {
  if (!task.cancel) {
    task.ratio = 0
    task.whichFile = index + 1
    const nextFile = restFiles?.shift()
    const nextIndex = ++index
    const totalChunks = Math.ceil(file.size / chunkSize)
    const promises: any = []
  
    // 上传下一个文件
    const next = async () => {
      if (nextFile) {
        await uploadFile(task, nextFile, path, nextIndex, done, allDone, restFiles)
      }
    }
    
    // 兼容0kb空文件上传
    if (file.size === 0) {
      try {
        const formData: any = new FormData()
        formData.append('file', file, file.name)
        await upload(formData, path, {
          'Content-Range': 0,
          'Content-Total': 0,
          'Content-First-Slice': 'true',
        })
        task.ratio = 100
        file.failed = false
      } catch (e) {
        file.failed = true
      } finally {
        file.done = true
        done()
        allDone()
      }
      return
    } else {
      // 非空文件上传
      let start: number = 0
      let completeCount = 0
      let num = 0
      for (let i = 0; i < totalChunks; i++) {
        const end = Math.min(start + chunkSize, file.size)
        const chunk = file.slice(start, end)
        const headers = {
          'Content-Range': start,
          'Content-Total': file.size,
          'Content-First-Slice': i === 0 ? 'true' : 'false',
        }
        start += chunk.size
        const formData: any = new FormData()
        formData.append('file', chunk, file.name)
    
        // 第一片任务创建完成后在异步调用其他分片任务
        if (i === 0) {
          try {
            await upload(formData, path, headers)
            task.ratio = Math.round(1 * 100 / totalChunks)
            completeCount += 1
            file.failed = false
          } catch (e) {
            file.failed = true
          } finally {
            // 仅一片调用完成回调
            if (totalChunks === 1) {
              file.done = true
              done()
              if (!nextFile) {
                allDone()
              } else {
                await next()
              }
            }
          }
        } else {
          promises.push(upload(formData, path, headers))
          // 分片Promise.all单个返回
          Promise.all(promises).then(() => {
            task.ratio = Math.round((1 + completeCount) * 100 / totalChunks)
            completeCount += 1
            // 有一片失败、文件全部分片失败
            if (file.failed !== true) {
              file.failed = false
            }
          }).catch(() => {
            file.failed = true
          }).finally(async () => {
            num++
            if (num === promises.length) {
              file.done = true
              done()
              if (!nextFile) {
                allDone()
              } else {
                await next()
              }
            }
          })
        }
      }
    }
  }
}

// 同步上传文件
const uploadFiles = async (task, path, callback) => {
  if (task.fileList?.length) {
    const _fileList = cloneDeep(task.fileList)
    const fileList = cloneDeep(task.fileList)
    const totalSize = fileList.reduce((size, file) => {
      if (file.size) {
        size += file.size
      }
      return size
    }, 0)

    const allDone = async () => {
      callback?.()
      task.loading = false
    }

    let index = 0
    const file = fileList.shift()
    if (file && !task.cancel) {
      // 全部task完成回调
      // 单个task完成回调
      const done = () => {
        const _size = _fileList.reduce((r, f) => {
          if (f.done) r += f.size
          return r
        }, 0)
        // 处理任务数据
        task.size = getDataSize(_size)
        task.totalSize = getDataSize(totalSize)
        // 任务进度
        task.progress = Math.round(_size * 100 / totalSize)
      }
      await uploadFile(task, file, path, index, done, allDone, fileList)
    }
  }
}

const getDataSize = (num = 0) => {
  return Xinnet.util.fileDiskSize(num, 2)
}

export default modal
